import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaStar, FaLeaf } from 'react-icons/fa';
import {successReveal} from "../animations/checkoutAnimations";


const SuccessHeroBit = ({ orderId }) => {
    return (
        <motion.div
            variants={successReveal}
            initial="initial"
            animate="animate"
            className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-sage/5 via-pearl to-champagne/5 p-8 md:p-12 mb-8 md:mb-12 text-center"
        >
            {/* Success Glow */}
            <motion.div
                animate={{
                    scale: [1, 1.1, 1],
                    opacity: [0.3, 0.5, 0.3]
                }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute inset-0 bg-gradient-to-br from-sage/10 via-transparent to-champagne/10"
            />

            <div className="relative z-10">
                {/* Success Icon */}
                <motion.div
                    animate={{
                        scale: [1, 1.1, 1],
                        rotate: [0, 360]
                    }}
                    transition={{ duration: 1.5 }}
                    className="inline-flex items-center justify-center mb-6 success-glow"
                >
                    <div className="relative">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-sage to-champagne flex items-center justify-center">
                            <FaCheckCircle className="w-12 h-12 text-white" />
                        </div>
                        <motion.div
                            animate={{
                                scale: [1, 1.2, 1],
                                rotate: [0, 180, 360]
                            }}
                            transition={{ duration: 2, repeat: Infinity }}
                            className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-gradient-to-br from-champagne to-sage flex items-center justify-center"
                        >
                            <FaStar className="w-5 h-5 text-white" />
                        </motion.div>
                        <motion.div
                            animate={{
                                scale: [1, 1.1, 1],
                                rotate: [0, -180, 0]
                            }}
                            transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
                            className="absolute -bottom-2 -left-2 w-10 h-10 rounded-full bg-gradient-to-br from-sage to-champagne flex items-center justify-center"
                        >
                            <FaLeaf className="w-5 h-5 text-white" />
                        </motion.div>
                    </div>
                </motion.div>

                {/* Success Message */}
                <motion.h1
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2, duration: 0.8 }}
                    className="font-heading text-4xl md:text-5xl lg:text-6xl font-light mb-4 text-charcoal"
                >
                    Thank you
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.8 }}
                    className="text-charcoal/60 text-lg md:text-xl max-w-2xl mx-auto mb-6"
                >
                    Your KROMAIC ritual begins now. Order #{orderId} has been confirmed.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.4 }}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-white/50 rounded-full"
                >
                    <span className="text-sm text-charcoal/70">Confirmation email sent</span>
                    <FaCheckCircle className="w-3 h-3 text-sage" />
                </motion.div>
            </div>

            {/* Floating Elements */}
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
                className="absolute left-8 top-8 w-12 h-12 opacity-5"
            >
                <svg viewBox="0 0 100 100" className="w-full h-full text-sage">
                    <circle cx="50" cy="50" r="40" stroke="currentColor" strokeWidth="1" fill="none" />
                </svg>
            </motion.div>

            <motion.div
                animate={{ rotate: -360 }}
                transition={{ duration: 80, repeat: Infinity, ease: "linear" }}
                className="absolute right-8 bottom-8 w-16 h-16 opacity-5"
            >
                <svg viewBox="0 0 100 100" className="w-full h-full text-champagne">
                    <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="1" fill="none" />
                </svg>
            </motion.div>
        </motion.div>
    );
};

export default SuccessHeroBit;